import { render, staticRenderFns } from "./RequestAccessModal.vue?vue&type=template&id=c20e04f4&scoped=true&"
import script from "./RequestAccessModal.vue?vue&type=script&lang=js&"
export * from "./RequestAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e04f4",
  null
  
)

export default component.exports